import React, {Dispatch, ReactNode, SetStateAction} from 'react';
import Table, {SetOrderByType} from 'shared/ui/Table/Table';
import {getServerIncidentColumns} from 'features/server/lib/serverIncidentHelper';
import IPagination from 'shared/api/model/IPagination';
import IOrderBy from 'shared/model/IOrderBy';
import IServerIncident from 'features/server/model/ServerIncident/IServerIncident';

import ServerIncidentRow from '../ServerIncidentRow/ServerIncidentRow';

interface IServerIncidentsProps {
    pagination?: IPagination<IServerIncident>,
    isLoading: boolean,
    hideServer?: boolean,
    hidePagination?: boolean,
    sort?: IOrderBy,
    setSort?: SetOrderByType,
    setPage?: Dispatch<SetStateAction<number>>,
    className?: string,
    emptyStateComponent?: ReactNode,
}

const ServerIncidents: React.FC<IServerIncidentsProps> = ({
    pagination,
    isLoading,
    hideServer = false,
    hidePagination = false,
    sort,
    setSort,
    setPage,
    className,
    emptyStateComponent = true,
}) => {
    return (
        <Table
            columns={getServerIncidentColumns(hideServer)}
            items={pagination?.items}
            rowFactory={(item) => (
                <ServerIncidentRow
                    key={item.uuid}
                    item={item}
                    hideServer={hideServer}
                />
            )}
            isLoading={isLoading}
            pagination={pagination && !hidePagination ? pagination : undefined}
            sort={sort}
            setSort={setSort}
            setPage={setPage}
            className={className}
            emptyStateComponent={emptyStateComponent}
        />
    );
};

export default ServerIncidents;
